import React from 'react';
import { LocationMessage } from '../../../../../chat-api';
import { generateMapUrl, generateMapPictureUrl } from '../../../../../utils/maps'
import { Link, Box } from '@material-ui/core'
import {
  ImageContainer,
  MediaRow,
  ImageItem,
  MediaTag
} from './styles';

interface MessageBodyLocationProps {
  message: LocationMessage;
  textColor?: string;
}

function MessageBodyLocation({ message, textColor }: MessageBodyLocationProps) {
  return (
    <ImageContainer as="sdiv">
      <MediaRow as="sdiv" style={{
        width: '330px', 
      }}>
        <ImageItem as="sdiv">
          <Link href={generateMapUrl(message.body.coordinates.coordinates[0],message.body.coordinates.coordinates[1], message.body.name, message.body.address)} target='_blank'>
            <ImageItem as="sdiv">
              <MediaTag src={generateMapPictureUrl(message.body.coordinates.coordinates[0],message.body.coordinates.coordinates[1])} alt="image_description" />
            </ImageItem>
            </Link>
        </ImageItem>
      </MediaRow>
      {message.body.name &&
        <Link href={generateMapUrl(message.body.coordinates.coordinates[0],message.body.coordinates.coordinates[1], message.body.name, message.body.address)} target='_blank'>
          <Box component="sdiv" fontSize='14px' color='#68bbe4' marginTop='.5em' marginLeft='6px'>
            {message.body.name}
          </Box>
        </Link>
      }
      {message.body.address &&
        <Box component="sdiv" fontSize='12px' marginLeft='6px' marginTop={message.body.name ? '0' : '.5em'} style={{color: textColor}}>
          {message.body.address}
        </Box>
      }
    </ImageContainer>
  );
}

export default React.memo(MessageBodyLocation);